import MinimizeIcon from '@mui/icons-material/KeyboardArrowDown'
import { memo } from 'react'
import IconButton from './IconButton'

interface ButtonChatHideProps {
    onClick(event?: any): void
}

const ButtonChatHide = memo(({ onClick }: ButtonChatHideProps) => (
    <IconButton title="Hide Chat" onClick={onClick}>
        <MinimizeIcon data-testid="KeyboardArrowDownIcon" />
    </IconButton>
))

export default ButtonChatHide
